export default class EventRegistryManager {
  constructor(store) {
    this.store = store;
  }

  editAssetComponentCommands(data) {
    this.store.commit('eventRegistryPlugin/editAssetComponentCommands', data);
  }

  editAssetCommands(asset) {
    this.store.commit('eventRegistryPlugin/editAssetCommands', asset);
  }

  editPaymentParamsCommands(paymentParams, assetComponent, lessorComponentShare) {
    
    this.store.commit('eventRegistryPlugin/editPaymentParamsCommands', paymentParams);
    this.store.commit('eventRegistryPlugin/editAssetComponentCommands', {
      assetComponent: assetComponent,
      assetComponentLength: 1,
    });
  }

  toggleModalToFormDirectoryEvent(value) {
    this.store.commit('eventRegistryPlugin/toggleModalToFormDirectoryEvent', value);
  }

  clearCommands() {
    this.store.commit('eventRegistryPlugin/deleteAllCommands');
  }

  loadContractVersions(contractId) {
    return this.store.dispatch("eventRegistryPlugin/loadAllDirectoryEventForContract", contractId);
  }

  loadIntegrationEvents(contractId) {
    return this.store.dispatch("eventRegistryPlugin/loadAllIntegrationEventForContract", contractId);
  }
}
